import { create } from 'zustand';

interface SettingsStoreBaseline {
  baselineConfig: any;
  setBaselineConfig: (collaborationConfig: any) => void;
}

export const useBaselineConfig = create<SettingsStoreBaseline>((set, get) => ({
  baselineConfig: null,
  setBaselineConfig: (baselineConfig) => set({ baselineConfig })
}));
